import { FC } from "react"
import classNames from "classnames"

type Tab = {
  identifier: string
  name: string
}

type Props = {
  tabs: Tab[]
  selectedTab: string
  selectTab: (id: string) => void
  searchPage?: boolean
}

export const Tabs: FC<Props> = (props) => {
  return (
    <>
      {props.searchPage ? (
        <div className="flex border-b-2 dark:border-secondary-11 space-x-2 justify-evenly">
          {props.tabs.map((tab) => (
            <button
              key={tab.identifier}
              className={classNames({
                "text-sm p-2  w-full hover:bg-white/5": true,
                "dark:text-zinc-400 text-light-2":
                  props.selectedTab !== tab.identifier,
                "bg-white/5 text-primary-3 ":
                  props.selectedTab === tab.identifier,
              })}
              onClick={() => props.selectTab(tab.identifier)}
            >
              {tab.name}
            </button>
          ))}
        </div>
      ) : (
        <div className="flex dark:border dark:border-secondary-11/50 justify-evenly rounded-lg dark:bg-primary-1 bg-[#ebc9a4]">
          {props.tabs.map((tab) => (
            <button
              key={tab.identifier}
              className={classNames({
                " px-2 py-3 text-xl w-full": true,
                "dark:text-zinc-400 text-light-2":
                  props.selectedTab !== tab.identifier,
                "dark:bg-secondary-2 bg-primary-12 dark:text-primary-11 text-white rounded-lg font-medium":
                  props.selectedTab === tab.identifier,
              })}
              onClick={() => props.selectTab(tab.identifier)}
            >
              {tab.name}
            </button>
          ))}
        </div>
      )}
    </>
  )
}
